<template>
  <div class="col  mt-5">
    <div class="row">

      <div class="col-6 mb-3">
        <h1>{{$t('menu.4')}}</h1>
      </div>
      <div class="col-6 mb-3 ">

      </div>
    </div>

    <span id="jsZaman"></span>


    <div class="card">
      <div class="card-body">
        <el-col :span="24">
          <el-table
            :data="veri()"
            style="width: 100%">
            <el-table-column
              :label="$t('kasa.adi')"
              prop="adi">
            </el-table-column>

            <el-table-column
              :label="$t('menu.4')"
              prop="adet">
            </el-table-column>


          </el-table>

        </el-col>
      </div>
    </div>

  </div>
</template>

<script>


  export default {
    data() {
      return {
        Data: [],
      }
    },
    methods: {
      veri() {
        if (this.Data != null) {
          var veri = this.Data.filter(data => !this.search || data.adi.toLowerCase().includes(this.search.toLowerCase()))
        } else if (this.Data == '') {
          var veri = this.Data;
        }
        return veri
      },

      StokListele() {
        this.$store.dispatch("dataver", {method: "get", url: "/urun/stok"})
          .then(response => {
            console.log(response)
            if (response.Status == 'OK') {
              this.Data = response.Data;
            } else {

            }
          });
      },

    },
    created() {
      this.StokListele()
    }
  }


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/stok/index.vue